import React from 'react';
import Typewriter from 'typewriter-effect';



class TypewriterAuto extends React.Component {
  render() {
    let textWriter = this.props.textWriter;
    return (
      <Typewriter
        options={{
          autoStart: true,
          loop: true,
        }}

        onInit={(typewriter) => {
          textWriter.map((obj) =>
            typewriter
              .typeString(obj.text)
              .pauseFor(5000)
              .deleteAll()
          )
          typewriter
            .start();
        }}
      />
    )
  }
}

export default TypewriterAuto;